// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"mobile-phone-control__container___KXivN"};
    if(module.hot) {
      // 1767926917487
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  